import { fetchJson } from './../core/ajax-json.js';
import Cookies from './../libs/tomcat-cookies.js';

const pixelTracking = {
	push: (name, amountValue, cb) => {
		fetchJson('/tracking/', { amount: amountValue }).then((response) => {
			let scriptHTML = response.result[name];
			if (scriptHTML === undefined) {
				console.error('Can not load pixel tracking');
			} else {
				scriptHTML = scriptHTML.replace('<script>', '');
				scriptHTML = scriptHTML.replace('</script>', '');
				const scriptElement = document.createElement('script');
				scriptElement.innerHTML = scriptHTML;
				document.body.appendChild(scriptElement);
			}
			if (cb !== undefined) {
				cb();
			}
		});
	},
	pushFromCookies: () => {
		if (Cookies.get('login') === 'true') {
			pixelTracking.push('login');
			Cookies.set('login', false);
		}
	}
};

export default pixelTracking;



// WEBPACK FOOTER //
// ./mobile-core/src/pixel-tracking/pixel-tracking.js